import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6efd5366"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "menu menu-sub menu-sub-dropdown menu-column w-350px w-lg-375px",
  "data-kt-menu": "true"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "d-flex flex-column bgi-no-repeat rounded-top",
  style: {"background-image":"url('/media/pattern-1.jpg')"}
}, [
  /*#__PURE__*/_createElementVNode("h3", { class: "text-white fw-bold px-9 mt-10 mb-6" }, "Notifications")
], -1))
const _hoisted_3 = { class: "tab-content" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = { class: "mb-0 me-2" }
const _hoisted_7 = {
  href: "#",
  class: "fs-7 text-gray-800 text-hover-primary fw-bolder"
}
const _hoisted_8 = { class: "text-gray-400 fs-7" }
const _hoisted_9 = { class: "badge badge-light fs-8 my-2 px-4" }
const _hoisted_10 = {
  key: 0,
  class: "loading-indicator overlay-layer card-rounded bg-dark bg-opacity-0"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-primary",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
], -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "py-3 text-center border-top" }
const _hoisted_14 = { class: "svg-icon svg-icon-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", null, [
        _createElementVNode("div", {
          onScroll: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleScroll && _ctx.handleScroll(...args))),
          class: "scroll-y mh-325px"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notificationList, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              onClick: ($event: any) => (_ctx.navigateToDeepLink(item)),
              class: _normalizeClass(["d-flex flex-stack p-5", { isSeen: _ctx.allSeen ? false : !item.isSeen }])
            }, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("a", _hoisted_7, _toDisplayString(item.title), 1),
                  _createElementVNode("div", _hoisted_8, _toDisplayString(item.body), 1)
                ])
              ]),
              _createElementVNode("span", _hoisted_9, _toDisplayString(item.createdAt.slice(0, 10)), 1)
            ], 10, _hoisted_4))
          }), 128))
        ], 32),
        (_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("a", {
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.markAll && _ctx.markAll(...args))),
            href: "#",
            class: "btn btn-color-gray-600 btn-active-color-primary"
          }, [
            _createTextVNode(" Mark All As Read "),
            _createElementVNode("span", _hoisted_14, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr064.svg" })
            ])
          ])
        ])
      ])
    ])
  ]))
}